<template>
  <div :class="`has-tag ${selected ? 'selected' : aptitude}`">
    {{ `${lot.area} has` }}
  </div>
</template>

<script>
import LotInfoWindow from './LotInfoWindow.vue'
import Vue from 'vue'

export default {
  components: {
    LotInfoWindow
  },
  props: {
    lot: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    markerConstructor: {
      type: Function,
      required: true
    },
    selectedLot: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      marker: {}
    }
  },
  computed: {
    selected () {
      return this.lot === this.selectedLot
    },
    aptitude () {
      switch (this.lot.aptitude) {
        case 'Agrícola':
          return 'greenBack'
        case 'Ganadera':
          return 'yellowBack'
        default:
          return 'greenBack'
      }
    }
  },
  mounted() {
    this.createMarker()
  },
  destroyed() {
    this.marker.map = null
  },
  methods: {
    createMarker() {
      this.marker = new this.markerConstructor({
        map: this.map,
        title: this.lot.title,
        position: this.lot.position,
        content: this.$el,
        gmpClickable: true
      })

      this.marker.addEventListener("gmp-click", (event) => {
        this.handleMarkerClick(event)
      })
    },
    setInfoWindowContent() {
      const InfoWindowComponent = Vue.extend(LotInfoWindow)
      const instance = new InfoWindowComponent({
        propsData: {
          services: this.lot.services
        }
      })

      instance.$mount()

      this.infoWindow.setContent(instance.$el)
    },
    handleMarkerClick(event) {
      this.$emit('markerClick', this.lot)
    }
  },
  watch: {
    'lot.visible' (newVal) {
      this.marker.map = newVal ? this.map : null
    }
  }
}
</script>

<style>
.has-tag {
  height: 1.75rem;
  border-radius: 0.875rem;
  color: #FFFFFF;
  font-size: 0.875rem;
  font-weight: 600;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem;
  font-family: "clearsans", sans-serif;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5);
  transition: background-color 0.25s;
}

.selected {
  background-color: #FFF;
  color: #000
}

.greenBack {
  background-color: #4E9306;
}

.yellowBack {
  background-color: #E5A20A;
}
</style>